import { useMapContext } from '../../contexts/mapContext';
import { useEffect } from 'react';
import { CHOROPLETH_COUNTRY_SOURCE, CHOROPLETH_STATE_SOURCE } from '../../constants/mapConstants';

export default function useChoroplethSource() {
	const [{ map }] = useMapContext();

	//country source
	useEffect(() => {
		if (!map) return;
		const oldSource = map.getSource(CHOROPLETH_COUNTRY_SOURCE);
		if (oldSource) map.removeSource(CHOROPLETH_COUNTRY_SOURCE);
		map.addSource(CHOROPLETH_COUNTRY_SOURCE, {
			type: 'vector',
			tiles: ['https://hagar.pnl.gov/VectorTiles/Country/{z}/{x}/{y}.pbf'],
			generateId: true,
		});
		return () => {};
	}, [map]);

	//state source
	useEffect(() => {
		if (!map) return;
		const oldSource = map.getSource(CHOROPLETH_STATE_SOURCE);
		if (oldSource) map.removeSource(CHOROPLETH_STATE_SOURCE);
		map.addSource(CHOROPLETH_STATE_SOURCE, {
			type: 'vector',
			tiles: ['https://hagar.pnl.gov/VectorTiles/Admin1/{z}/{x}/{y}.pbf'],
			generateId: true,
		});
		return () => {};
	}, [map]);
}
